module.exports = __webpack_public_path__ + "static/media/SYNC.56cd7c30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons/SYNC.svg
// module id = 632
// module chunks = 0